var $ = jQuery.noConflict();
var isMobile;
var isTablet;

(function ($) {
    "use strict";

    var $body = $("body");
    var $html = $("html");

    initDefaultFileControls();

    //
    // underline animation
    // --------------------------------------------------
    applyClassOnScroll(".section-heading", "-in-view");
    function applyClassOnScroll(selector, cls) {
        var targets = document.querySelectorAll(selector);
        if (typeof IntersectionObserver === "function") {
            var options = {
                rootMargin: "0px",
                threshold: 1.0
            };
            var callback = function (entries, observer) {
                entries.forEach(function (entry) {
                    if (entry.intersectionRatio === 1) {
                        if (cls) $(entry.target).addClass(cls);
                        observer.unobserve(entry.target);
                    }
                });
            };

            var observer = new IntersectionObserver(callback, options);
            targets.forEach(function (t) {
                observer.observe(t);
            });
        } else {
            if (cls) $(targets).addClass(cls);
        }
    }

    //
    // device detect
    // --------------------------------------------------

    //    $(".demo-btn-wrapper a").on("click", function () {
    //        $("#comebacksoon").modal();
    //    });

    if ($html.hasClass("desktop")) {
        $html.addClass("is-desktop");
        isMobile = false;
    } else {
        $html.addClass("is-mobile");
        isMobile = true;
    }
    if ($html.hasClass("ie9")) {
        var isIE9 = true;
    }

    if ($html.hasClass("tablet")) {
        isTablet = true;
    }

    if (!isMobile || isTablet) {
        fn_scrollReveal();
        fn_particles();
    }

    //
    // core
    // --------------------------------------------------

    function fn_core() {
        // smooth scroll

        var offset = -$(".site-header > .navbar").height();

        //$(window).on("load", function () {
        //    const hash = window.location.hash.substring(1);
        //    if (!hash)
        //        return;

        //    $("#" + hash).velocity("stop").velocity("scroll",
        //        {
        //            duration: 1000,
        //            easing: [0.710, 0.100, 0.3, 1.000],
        //            offset: offset
        //        });
        //});

        $("a[href^='#']").on("click", function (e) {
            e.preventDefault();

            var linkTag = $(this);
            var id = linkTag.attr("href").slice(1);

            if (history && history.pushState) {
                history.pushState({}, "", this.href);
            } else {
                window.location.hash = id;
            }

            $("#" + id)
                .velocity("stop")
                .velocity("scroll", {
                    duration: 1000,
                    easing: [0.71, 0.1, 0.3, 1.0],
                    offset: offset
                });
        });

        // scrollspy
        $body.scrollspy({
            target: ".navbar",
            offset: 120
        });

        // bootstrap collapse
        $(".navbar-nav li a").on("click", function (e) {
            if (!$(this).parent().hasClass("dropdown")) {
                $(".navbar-collapse").collapse("hide");
            }
        });
    }
    fn_core();

    function resizeCarousel() {
        $(".carousel-item.loading").removeClass("loading");
        var $items = $(".featured-events__container .featured-events__page .featured-events__item");

        if ($items.length === 0) return;

        var firstItemWidth = $items.eq(0).width();

        $items.each(function (i, el) {
            $(el).height(firstItemWidth);
        });
    }

    resizeCarousel();

    //
    // scroll reveal
    // --------------------------------------------------

    function fn_scrollReveal() {
        if ((!isMobile || isTablet) && !isIE9) {
            var config = {
                origin: "bottom",
                distance: "20px",
                duration: 800,
                delay: 0,
                rotate: { x: 0, y: 0, z: 0 },
                opacity: 0,
                scale: 0,
                easing: "ease-in-out",
                container: null,
                mobile: false,
                reset: false,
                useDelay: "always",
                viewFactor: 0.2,
                viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
                afterReveal: function (domEl) {},
                afterReset: function (domEl) {}
            };

            window.sr = new ScrollReveal(config);
            if ($("[data-sr=top]").length) {
                sr.reveal("[data-sr=top]", { origin: "top" });
            }
            if ($("[data-sr=right]").length) {
                sr.reveal("[data-sr=right]", { origin: "right" });
            }
            if ($("[data-sr=bottom]").length) {
                sr.reveal("[data-sr=bottom]", { origin: "bottom" });
            }
            if ($("[data-sr=left]").length) {
                sr.reveal("[data-sr=left]", { origin: "left" });
            }
        }
    }

    function fn_particles() {
        if ($("#particles-js").length === 0) return;

        $body.addClass("is-site-bg-particles");
        $(".site-bg-effect, .site-bg-canvas").remove();

        particlesJS("particles-js", {
            particles: {
                number: {
                    value: 25,
                    density: {
                        enable: true,
                        value_area: 500
                    }
                },
                color: {
                    value: "#cdcdcd"
                },
                opacity: {
                    value: _particles_opacity,
                    random: false,
                    anim: {
                        enable: false,
                        speed: 1,
                        opacity_min: 0.1,
                        sync: false
                    }
                },
                size: {
                    value: 4,
                    random: true,
                    anim: {
                        enable: false,
                        speed: 40,
                        size_min: 0.1,
                        sync: false
                    }
                },
                line_linked: {
                    enable: true,
                    distance: 150,
                    color: "#cdcdcd",
                    opacity: _particles_link_opacity,
                    width: 1
                },
                move: {
                    enable: true,
                    speed: 6,
                    direction: "none",
                    random: false,
                    straight: false,
                    out_mode: "out",
                    bounce: false,
                    attract: {
                        enable: false,
                        rotateX: 600,
                        rotateY: 1200
                    }
                }
            },
            interactivity: {
                detect_on: "canvas",
                events: {
                    onhover: {
                        enable: false,
                        mode: "repulse"
                    },
                    onclick: {
                        enable: false,
                        mode: "push"
                    },
                    resize: true
                },
                modes: {
                    grab: {
                        distance: 400,
                        line_linked: {
                            opacity: 1
                        }
                    },
                    bubble: {
                        distance: 400,
                        size: 40,
                        duration: 2,
                        opacity: 8,
                        speed: 3
                    },
                    repulse: {
                        distance: 200,
                        duration: 0.4
                    },
                    push: {
                        particles_nb: 4
                    },
                    remove: {
                        particles_nb: 2
                    }
                }
            },
            retina_detect: true
        });
    }

    $("#expoName").bind("keyup", "change", function () {
        var trimmed = $(this).val().trim().replace(" ", "");
        var start = this.selectionStart,
            end = this.selectionEnd;
        if ($(this).val() !== trimmed) {
            $(this).val(trimmed);
        }
        this.setSelectionRange(start, end);
    });

    $("#expoName").click(function () {
        this.scrollIntoView({
            behavior: "smooth",
            block: "center"
        });
    });

    $("#order-event").submit(function (e) {
        var self = this;
        e.preventDefault();
        $(self).data("validator").settings.submitHandler = function (form) {
            $("[type=submit]", form).prop("disabled", true);
            self.submit();
        };
        $(self).valid();
    });

    $("#contactForm").submit(function (e) {
        var self = this;
        e.preventDefault();

        $(this).data("validator").settings.submitHandler = function (form) {
            $("[type=submit]", form).prop("disabled", true);
            if (window.grecaptcha) {
                window.grecaptcha.ready(function () {
                    var el = document.getElementById("ReCaptchaToken");
                    window.grecaptcha
                        .execute(el.dataset.key, { action: "index" })
                        .then(function (token) {
                            el.value = token;
                            self.submit();
                        })
                        .catch(function () {
                            $("[type=submit]", self).prop("disabled", false);
                        });
                });
            } else self.submit();
        };
        $(self).valid();
    });

    document.getElementById("intro-video").src = "https://www.youtube.com/embed/XICKkiO2KXI";

    $('.testimonials-header').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.testimonials-nav__body',
        arrows: false,
        draggable: false,
        fade: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    draggable: true,
                }
            }
        ]
    });
    $('.testimonials-nav__body').slick({
        autoplay: true,
        autoplaySpeed: 10000,
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.testimonials-header',
        prevArrow: '.testimonials-nav__prev',
        nextArrow: '.testimonials-nav__next',
        centerMode: true,
        centerPadding: 0,
        dots: false,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });    

})(jQuery);

function deleteAllCookies() {
    var cookies = document.cookie.split("; ");
    for (var c = 0; c < cookies.length; c++) {
        var d = window.location.hostname.split(".");
        while (d.length > 0) {
            var cookieBase =
                encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) +
                "=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=" +
                d.join(".") +
                " ;path=";
            var p = location.pathname.split("/");
            document.cookie = cookieBase + "/";
            while (p.length > 0) {
                document.cookie = cookieBase + p.join("/");
                p.pop();
            }
            d.shift();
        }
    }
    cookies = document.cookie.split("; ");
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
}

function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
}


let scrollTopValue = 0;
const disableScroll = () => {
    scrollTopValue = document.documentElement.scrollTop;
    document.documentElement.classList.add("noscroll");
    document.documentElement.style.top = -scrollTopValue + "px";
};
const enableScroll = () => {
    document.documentElement.classList.remove("noscroll");
    document.documentElement.scrollTo({ top: scrollTopValue });
};
const video = () => {
    const wrapper = document.querySelector("#videoWrapper");
    const state = {
        wrapper,
        container: document.querySelector("#videoContainer"),
        closeBtn: document.querySelector("#closeBtn"),
        classList: wrapper.classList,
        bannerRightCol: document.querySelector("#bannerRightCol"),
        home: document.querySelector("#home"),
        isExpanded: wrapper.classList.contains("expanded")
    };
    const expand = () => {
        if (!state.isExpanded) {
            state.home.style.zIndex = "unset";
            state.bannerRightCol.style["transition"] = "";
            state.bannerRightCol.style["-webkit-transition"] = "";
            state.bannerRightCol.style["transform"] = "";
            state.bannerRightCol.style["-webkit-transform"] = "";
            disableScroll();
            state.classList.add("expanded");
        }
    };
    const close = () => {
        if (state.isExpanded) {
            state.classList.remove("expanded");
            state.home.style.zIndex = "";
            enableScroll();
        }
    };
    return { state, expand, close }
};
const _stopClickFloat = (e) => {
    e?.preventDefault();
    e?.stopPropagation();
}
const wrapperClickHandler = () => {
    const { state, expand, close } = video();
    if (state.isExpanded) {
        close();
    } else {
        expand();
    }
}
const containerClickHandler = (e) => {
    if (video().state.isExpanded) {
        _stopClickFloat(e);
    }
}
const closeBtnClickHandler = (e) => {
    _stopClickFloat(e);
    video().close();
}
document.addEventListener("DOMContentLoaded", () => {
    const  { wrapper, container, closeBtn } = video().state;
    wrapper.addEventListener("click", wrapperClickHandler);
    closeBtn.addEventListener("click", closeBtnClickHandler);
    container.addEventListener("click", containerClickHandler);
})
